/* eslint-disable react-hooks/exhaustive-deps */
import { consumirServicioEncirptacion } from 'api/index';
import classNames from 'classnames';
import { ambienteAplicacion, urlActualizarCotizadorMex } from 'constants/urls';
import useCustomToast from 'hooks/useCustomToasts';
import React, { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { Button, Collapse, Row } from 'reactstrap';
import useParametrosPago from 'redux/hooks/useParametrosPago';
import { PRODUCTOS } from 'utils/constants';
import { procesarPrecio } from 'utils/funciones';
import { emailRegex } from '../InputsMex/validaciones';

const BTN_PAGO = {
  CALCULAR: 'CALCULAR PRIMA',
  PAGAR: 'PAGAR',
};

const ComponenteValoresTotales = ({
  totales,
  mostrarActualizar,
  onActualizarValoresTarifa,
  onClickPagar,
  recalculando = false,
  puedeEmitir,
}) => {
  const methods = useForm({ mode: 'onChange' });

  const { register, errors } = methods;

  const [posicion, setPosicion] = useState(totales[0].banderaModena ? 0 : 1);

  const { addWarningToast, addSuccessToast } = useCustomToast();
  const [enviandoCorreo, setEnviandoCorreo] = useState(false);

  const { setTarifacion } = useSelector((state) => state.CarritoMex);

  const { contratante } = useSelector(({ cotizacionReducer }) => ({
    contratante: cotizacionReducer?.contratantes?.find(
      (e) => e.cotizador === PRODUCTOS.TRAVELBTA,
    ),
  }));

  const { handleContinue } = useParametrosPago();

  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  useEffect(() => {
    methods.setValue('email', contratante?.data?.usuCorreo);
  }, []);

  const { setIdCotizacionActual } = useSelector((state) => state.CarritoMex);

  const [terminos, setTerminos] = useState(false);

  const onGuardarEnviarCotizacion = async (data) => {
    setEnviandoCorreo(true);
    let Data = {
      ambiente: ambienteAplicacion,
      prodCodigo: setIdCotizacionActual.cotizador,
      pasoCodigo: 'enviarCorreoCotizacion',
      items: {
        cotCodigo: setIdCotizacionActual.id,
        cotCorreo: data.email,
      },
    };
    //Agregar código para enviar el correo
    let dataRes = await consumirServicioEncirptacion(
      urlActualizarCotizadorMex,
      Data,
    );
    if (dataRes.transaccion === false) {
      addWarningToast('Ha ocurrido un error al intentar enviar el correo');
    } else {
      addSuccessToast(`Se ha enviado un correo a ${data.email} con la información`);
    }
    setEnviandoCorreo(false);
    methods.setValue('email', data.email);
  };

  return (
    <React.Fragment>
      <Row>
        <div className="align-self-center col-6 col-xl-7">
          <div className="text-mex detalle__pago__titulo">Descripción de pago</div>
        </div>
        <div className="text-right col-6 col-xl-5">
          <ul className="step-mex text-right">
            {totales.map((total, i) => (
              <li
                className={classNames({
                  'li-step-moneda': true,
                  active: i === posicion,
                })}
                key={i}
                onClick={() => setPosicion(i)}
              >
                <Button
                  className="btn-moneda"
                  style={{
                    color: i === posicion ? 'white' : '#1b1b1b',
                    outline: 'none',
                  }}
                >
                  {total.monedaNombre}
                </Button>
              </li>
            ))}
          </ul>
        </div>
        {totales[posicion]?.cambioDia && (
          <div className="col-12">
            <div className="texto-cambio-moneda">{totales[posicion]?.cambioDia}</div>
          </div>
        )}
      </Row>

      <Row className="mb-5">
        <div className="col-6">
          <h5 className="detalle__pago__label">Prima neta</h5>
        </div>
        <div className="col-6 text-right">
          <div className="detalle__pago__precio">
            {procesarPrecio(
              totales[posicion].primaNeta,
              totales[posicion].monedaSimbolo,
            )}
          </div>
        </div>
      </Row>

      <Row className="my-2">
        <div className="col-12">
          <div className="row">
            <div className="col-7 col-md-8">
              <div className="detalle__pago__titulo text-mex">Cargos Extra</div>
            </div>
            <div className="col-5 col-md-4">
              <div className="detalle__pago__precio__bold text-right">
                {procesarPrecio(
                  totales[posicion].impuestosTotal,
                  totales[posicion].monedaSimbolo,
                )}
              </div>
            </div>
          </div>

          {totales[posicion]?.impuestosGenerados?.map((impuestos, i) => {
            return (
              <Row key={i}>
                <div className="col-6">
                  <div className="detalle__pago__label ml-4">
                    {impuestos.impuestoNom}
                  </div>
                </div>
                <div className="col-6">
                  <div className="detalle__pago__precio  text-right">
                    {procesarPrecio(
                      impuestos.impuestoValor,
                      totales[posicion].monedaSimbolo,
                    )}
                  </div>
                </div>
              </Row>
            );
          })}
        </div>
      </Row>

      <Row className="my-2">
        <div className="col-6">
          <div className="detalle__pago__titulo text-mex">Total a pagar</div>
        </div>
        <div className="col-6 text-right">
          <div className="detalle__pago__precio__bold">
            {procesarPrecio(
              totales[posicion].primaTotal,
              totales[posicion].monedaSimbolo,
            )}
          </div>
        </div>
      </Row>

      {totales[posicion]?.planPagos && (
        <div className="row justify-content-center">
          <div className="col-12">
            <h4 className="cpointer" onClick={toggle}>
              Detalle de pagos <i className="pi pi-chevron-down" />
            </h4>
            <Collapse isOpen={isOpen}>
              {totales[posicion]?.planPagos?.map((e, index) => (
                <div className="w-100" key={index * 123}>
                  <p className="d-inline ml-2" style={{ fontSize: '20px' }}>
                    {e?.labelPago}
                  </p>
                  <p className="float-right" style={{ fontSize: '20px' }}>
                    {procesarPrecio(e?.primaTotal, totales[posicion]?.monedaSimbolo)}
                  </p>
                </div>
              ))}
            </Collapse>
          </div>
        </div>
      )}

      <Row className=" mt-5">
        <div className="col-12">
          <input
            type="checkbox"
            id="cbox2"
            className="chek-terminos"
            value={terminos}
            onChange={() => {
              if (puedeEmitir) {
                setTerminos(!terminos);
              } else {
                setTerminos(false);
              }
            }}
          />
          <label htmlFor="cbox2" className="term-condiciones">
            Aceptar Términos y Condiciones
          </label>
        </div>
      </Row>

      <div className="row">
        <div className="col-12">
          {mostrarActualizar && (
            <Button
              className="btn btn-block btn-primary fe-pulse"
              onClick={handleContinue(onActualizarValoresTarifa)}
            >
              {BTN_PAGO.CALCULAR}
            </Button>
          )}

          {!mostrarActualizar && (
            <button
              className="btn btn-primary btn-block"
              onClick={handleContinue(onClickPagar)}
              disabled={!terminos}
            >
              {BTN_PAGO.PAGAR}
            </button>
          )}
        </div>
      </div>

      <div className="row">
        <div className="col-12 text-right">
          <a
            href={setTarifacion.cotUrl ? setTarifacion.cotUrl : '#'}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary"
          >
            Descargar Cotización
          </a>
        </div>
      </div>

      <FormProvider {...methods}>
        <div className="row">
          <div className="col-12 my-3">
            {!enviandoCorreo && (
              <React.Fragment>
                <label
                  className="lbl-env-correo"
                  htmlFor="env-correo-api"
                  style={{ fontSize: '20px' }}
                >
                  Confirma tu correo para recibir tu cotización ahora
                </label>
                <div className="input-group input-group-lg">
                  <input
                    type="text"
                    className="form-control enviar-cot"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-lg"
                    placeholder="Ingresa tu correo "
                    id="env-correo-api"
                    name="email"
                    ref={register({
                      required: 'Este campo es obligatorio',
                      pattern: {
                        value: emailRegex,
                        message: 'Ingrese un correo válido',
                      },
                    })}
                  />

                  <div className="input-group-prepend">
                    <button
                      className="btn btn-primary rounded-right text-uppercase"
                      onClick={methods.handleSubmit(onGuardarEnviarCotizacion)}
                      disabled={recalculando}
                    >
                      Enviar cotización
                    </button>
                  </div>
                </div>

                <strong className="error-msg-input">{errors?.email?.message}</strong>
              </React.Fragment>
            )}
            {enviandoCorreo && (
              <React.Fragment>
                <h3 className="font-mex">Enviando correo...</h3>
              </React.Fragment>
            )}
          </div>
        </div>
      </FormProvider>
    </React.Fragment>
  );
};
export default ComponenteValoresTotales;

/*

           <div className="float-right">
              <button
                className="d-inline-block"
                style={{
                  width: '100px',
                  padding: '5px',
                  border: '1px solid #001871',
                  borderRight: 'none',
                  textAlign: 'center',
                  fontSize: '20px',
                  backgroundColor: 'white',
                  outline: 'none',
                  cursor: 'pointer',
                }}
              >
                PESOS
              </button>
              <button
                className="d-inline-block"
                style={{
                  width: '100px',
                  padding: '5px',
                  border: '1px solid #001871',
                  textAlign: 'center',
                  fontSize: '20px',
                  backgroundColor: 'white',
                  outline: 'none',
                  cursor: 'pointer',
                }}
              >
                DOLARES
              </button>
            </div>
          

*/
